export default "__VITE_ASSET__612e26a3__"